const updateItems = [
  { date: '2026.08.01', title: '《暗夜追踪2》正式定档，续集故事线首次曝光', tag: '新片', tagColor: 'bg-primary-100 text-primary-700' },
  { date: '2026.07.31', title: '《星河战纪》第三季播放量突破10亿，制作组发文庆祝', tag: '热闻', tagColor: 'bg-accent-100 text-accent-700' },
  { date: '2026.07.30', title: '平台新增4K超清专区，百部经典老片修复重映', tag: '公告', tagColor: 'bg-secondary-100 text-secondary-700' },
  { date: '2026.07.29', title: '《都市寓言》入围国际电影节最佳外语片提名', tag: '喜讯', tagColor: 'bg-accent-100 text-accent-700' },
  { date: '2026.07.28', title: '暑期档专题页面上线，精选50部适合全家观看的影片', tag: '专题', tagColor: 'bg-primary-100 text-primary-700' },
  { date: '2026.07.27', title: '移动端播放器全面升级，新增倍速播放和记忆续播功能', tag: '更新', tagColor: 'bg-secondary-100 text-secondary-700' },
  { date: '2026.07.26', title: '《迷雾深渊》导演版加长片段独家上线91电影视频', tag: '独家', tagColor: 'bg-primary-100 text-primary-700' },
  { date: '2026.07.25', title: '韩剧专区改版完成，新增按评分和热度双重排序功能', tag: '改版', tagColor: 'bg-secondary-100 text-secondary-700' },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-3 whitespace-nowrap">最新动态</span>
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950">更新快讯 · 影视前沿</h2>
          <p className="text-sm text-foreground-600 mt-2 max-w-lg mx-auto">最新影视资讯、平台动态与独家内容一网打尽</p>
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="relative pl-8 md:pl-0">
            <div className="absolute left-3 md:left-[50%] top-0 bottom-0 w-px bg-background-200 hidden md:block"></div>
            <div className="absolute left-0 top-0 bottom-0 w-px bg-background-200 md:hidden"></div>

            <div className="space-y-0">
              {updateItems.map((item, i) => (
                <div key={i} className={`relative flex flex-col md:flex-row gap-3 md:gap-0 pb-6 md:pb-8 ${i < updateItems.length - 1 ? '' : 'pb-0'}`}>
                  <div className="absolute left-0 md:left-[50%] w-3 h-3 rounded-full bg-primary-500 border-2 border-background-50 transform -translate-x-1/2 mt-1.5 z-10 hidden md:block"></div>
                  <div className="pl-6 md:pl-0 md:w-1/2 md:pr-10 md:text-right">
                    {i % 2 === 0 && (
                      <div className="hidden md:block">
                        <span className="text-xs font-medium text-foreground-400 whitespace-nowrap">{item.date}</span>
                        <span className={`ml-2 px-2 py-0.5 rounded text-[10px] font-semibold ${item.tagColor} whitespace-nowrap`}>{item.tag}</span>
                        <h3 className="font-medium text-sm text-foreground-900 mt-1">{item.title}</h3>
                      </div>
                    )}
                  </div>
                  <div className="md:w-1/2 md:pl-10">
                    {i % 2 === 1 && (
                      <div className="hidden md:block">
                        <span className="text-xs font-medium text-foreground-400 whitespace-nowrap">{item.date}</span>
                        <span className={`ml-2 px-2 py-0.5 rounded text-[10px] font-semibold ${item.tagColor} whitespace-nowrap`}>{item.tag}</span>
                        <h3 className="font-medium text-sm text-foreground-900 mt-1">{item.title}</h3>
                      </div>
                    )}
                    <div className="md:hidden">
                      <div className="relative">
                        <div className="absolute left-[-22px] top-2 w-2.5 h-2.5 rounded-full bg-primary-500 border-2 border-background-50"></div>
                        <div className="flex items-center gap-2 mb-1 flex-wrap">
                          <span className="text-xs font-medium text-foreground-400 whitespace-nowrap">{item.date}</span>
                          <span className={`px-2 py-0.5 rounded text-[10px] font-semibold ${item.tagColor} whitespace-nowrap`}>{item.tag}</span>
                        </div>
                        <h3 className="font-medium text-sm text-foreground-900 leading-relaxed">{item.title}</h3>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}